import { NgModule } from '@angular/core';
import { WidgetSettingsModule } from '../../widget-settings/widget-settings.module';
import { FiAppearanceStartPageEditControlContentWrap } from './widget-settings-wrap.component';
import { FiAppearanceWidgetSettingsComponent } from './widget-settings.component';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [CommonModule, WidgetSettingsModule],
    declarations: [FiAppearanceStartPageEditControlContentWrap, FiAppearanceWidgetSettingsComponent],
    exports: [FiAppearanceStartPageEditControlContentWrap],
})
export class FiAppearanceWidgetSettingsWrapModule {}
